import { Shark, Utils, View } from "shark-mvc";
import $ from "jquery";


import templateContent from "./global-reports.html";

import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "Components/mainNavComponent";
import { tableSorterComponent } from "../../_shark_components/tableSorter/tableSorterComponent";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class GlobalReportsView extends View {
	constructor () {
		super("globalReportsView");
		this.setTemplate(templateContent);
	}

	afterComponentsPreRender () {
		let fullReportList = Shark.get("fullReportList");
	
		if (fullReportList) {
	// 		const quotationActiveFilters = Shark.get("quotationActiveFilters");
	// 		const dateRangeFilter = Shark.get("dateRangeFilter");
			let counter = 0;
	
			fullReportList.forEach((item) => {
				item.__render = true;
	
	// 			if (!dateRangeFilter.ignoreDateRange && (item.__referenceDate < dateRangeFilter.__from || item.__referenceDate > dateRangeFilter.__to)) {
	// 				item.__render = false;
	// 			}
	// 			else {
	// 				item.__render = item.status === 0 && quotationActiveFilters.showWaiting ||
	// 				item.status === 1 && quotationActiveFilters.showPending ||
	// 				item.status === 2 && quotationActiveFilters.showAccepted ||
	// 				item.status === 3 && quotationActiveFilters.showRefused ||
	// 				item.status === 4 && quotationActiveFilters.showUploaded
	// 				;
	// 			}
	
	// 			if (item.__render && quotationActiveFilters.agentGuid !== "" && quotationActiveFilters.agentGuid !== item.siteInfoSheetData.agentGuid) {
	// 				item.__render = false;
	// 			}
	
				if (item.__render) {
					item.__displayIndex = counter + 1;
					item.__index = counter;
					counter++;
				}
			});
		}
	}
	
	
	beforeLoad () {
		followUpComponent.set("targetItem", null);
	
		// if (Shark.get("agentList").length === 0) {
		// 	userManager.getList();
		// }
	
		// if (Shark.get("clientList").length === 0) {
		// 	clientManager.getList();
		// }	
	
		// if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
		// 	applicatorTeamManager.getList();
		// }
	
		// tableSorterComponent.setSortField("__referenceDate", 9, "date");
		// tableSorterComponent.set({
		// 	tableContentList: Shark.get("quotationList")
		// });
		
		
		clientManager.getFullReportList()
		.then(getFullReportListResponse => {
			//const activityFullReport = activityReportComponent.extractReport(getFullReportListResponse.data.fullReportList);
			console.log({activityFullReport});
		});
	}
	
	beforeRender () {
	
		const fullReportList = Shark.get("fullReportList");
	
		console.log({fullReportList});
	// 	const hilitedQuotation = Shark.get("hilitedQuotation");
	// 	const quotationList = Shark.get("quotationList");
	
	// 	if (hilitedQuotation) {
	// 		quotationList.forEach(item => item.__hilited = item.guid === hilitedQuotation.guid)
	// 	}
	
	// 	console.log({quotationList});
		
	// 	tableSorterComponent.set({
	// 		tableContentList: quotationList
	// 	});
	
	// 	followUpComponent.set({
	// 		sourceList: quotationList
	// 	});
	}

	init () {
		this.addComponents([dateRangeFilterComponent, followUpComponent, liveSearchComponent, mainNavComponent, tableSorterComponent, waitBoxComponent]);
	
		const quotationActiveFilters = Shark.getInstance(null, {
			agentGuid: "",
			showAccepted: true,
			showPending: true,
			showRefused: false,
			showUploaded: true,
			showWaiting: true,
		});
	
		quotationActiveFilters.on("dataChanged", function (event, data) {
			Shark.render();
		});
	
		Shark.set({
			agentList: Shark.get("agentList") || [],
			clientList: Shark.get("clientList") || [],
			fullReportList: [],
			quotationList: Shark.get("quotationList") || [],
			quotationActiveFilters,
		});
	
		this.set({
			__htmlTitle: "Lista Preventivi | IPM HUB"
		});
	
		// pagerComponent.set({
		// 	currPage: 0,
		// 	pageSize: 500
		// });
	}
}

const globalReportsView = new GlobalReportsView();
// var globalReportsView = Shark.createJaw("globalReportsView");
// globalReportsView.templateContent = templateContent;

// globalReportsView.addMethod("addQuotationBtn_clickHandler", function (event, data) {
// 	const quotationList = Shark.get("quotationList");
// 	const currQuotation = Utils.safp(quotationList, "guid", data.guid);

// 	Shark.set({currQuotation});

// 	if (currQuotation && confirm("Vuoi inviare una nuova revisione per questo Preventivo?")) {
// 		siteInfoSheetManager.getByGuid(currQuotation.siteInfoSheetGuid)
// 		.then(sharkResponse => {
// 			if (sharkResponse.status === "ok") {
// 				Shark.set({currSiteInfoSheet: sharkResponse.data});
// 				let newCode = currQuotation.code;
// 				const revIndex = newCode.indexOf("REV.");
// 				let newRevisionNumber = 0;

// 				if (revIndex > -1) {
// 					newRevisionNumber = parseInt(newCode.substr(revIndex + 5, 2));

// 					if (!isNaN(newRevisionNumber)) {
// 						newRevisionNumber++;
// 						newCode = newCode.substr(0, revIndex) + "REV." + Utils.zeroFill(newRevisionNumber, 2)
// 					}
// 				}
// 				else {
// 					newCode += " REV.01";
// 					newRevisionNumber = 1;
// 				}

// 				siteInfoSheetActionsComponent.show("", newCode, currQuotation);
// 				console.log("addQuotationBtn_clickHandler > response", currQuotation, sharkResponse.data);
// 			}
// 		});
// 	}
// });

// globalReportsView.addMethod("afterRender", function () {
// 	$(function () {
// 		$('[data-toggle="popover"]').popover()
// 	});
// });


// globalReportsView.addMethod("beforeUnload", function () {
// 	Shark.set({hilitedQuotation: null});
// });


// globalReportsView.addMethod("refreshListBtn_clickHandler", function () {
// 	Shark.set({hilitedQuotation: null});
// 	document.querySelector("#refreshListBtn").classList.add("loading");
// 	quotationManager.getList();
// });


// globalReportsView.addMethod("showQuotationInfoBtn_clickHandler", function (event, data) {
// 	const quotationList = Shark.get("quotationList");
// 	const currQuotation = Utils.safp(quotationList, "guid", data.guid);

// 	if (currQuotation.cca.trim() !== "") {

// 		waitBoxComponent.show();
		
// 		fetch("https://api.teamup.com/ksw14p2npoy3azxawq/events?_teamup_token=720642e87891cd36d671e303585b8cb4596e81d9d8bcc3e05fc5e5a3fd114031&startDate=2019-01-01&endDate=2020-12-31&query=" + currQuotation.cca)
// 		.then(response => response.json())
// 		.then(teamUpResponse => {
// 			console.log({teamUpResponse});

// 			if (teamUpResponse.events.length > 0) {
// 				const eventData = teamUpResponse.events[0];
// 				const startDate = moment(eventData.start_dt);
// 				const endDate = moment(eventData.end_dt);

// 				fetch("https://api.teamup.com/ksw14p2npoy3azxawq/subcalendars/" + eventData.subcalendar_id + "?_teamup_token=720642e87891cd36d671e303585b8cb4596e81d9d8bcc3e05fc5e5a3fd114031")
// 				.then(response => response.json())
// 				.then(teamUpCalendarResponse => {

// 					waitBoxComponent.hide();

// 					setTimeout(() => {
// 						alert(`Stato: ${currQuotation.__statusLabel}\nCCA: ${currQuotation.cca ? currQuotation.cca : "N/D"}\nNumero Preventivo: ${currQuotation.code}\nData Preventivo: ${currQuotation.__referenceDateLabel}\nData Invio: ${currQuotation.__sendingDateLabel}\n\nSquadra: ${teamUpCalendarResponse.subcalendar.name.substr(24)}\nInizio cantiere: ${startDate.format("DD/MM/YYYY")}\nFine cantiere: ${endDate.format("DD/MM/YYYY")}`);
// 					}, 200);
// 				});
// 			}
// 			else {
// 				waitBoxComponent.hide();

// 				setTimeout(() => {
// 					alert(`Stato: ${currQuotation.__statusLabel}\nCCA: ${currQuotation.cca ? currQuotation.cca : "N/D"}\nNumero Preventivo: ${currQuotation.code}\nData Preventivo: ${currQuotation.__referenceDateLabel}\nData Invio: ${currQuotation.__sendingDateLabel}`);
// 				}, 200);
// 			}
// 		})
// 		.catch(error => {
// 			waitBoxComponent.hide();

// 			setTimeout(() => {
// 				alert(`Stato: ${currQuotation.__statusLabel}\nCCA: ${currQuotation.cca ? currQuotation.cca : "N/D"}\nNumero Preventivo: ${currQuotation.code}\nData Preventivo: ${currQuotation.__referenceDateLabel}\nData Invio: ${currQuotation.__sendingDateLabel}`);
// 			}, 200);
// 		});
// 	}
// 	else {
// 		if (currQuotation) {
// 			alert(`Stato: ${currQuotation.__statusLabel}\nCCA: ${currQuotation.cca ? currQuotation.cca : "N/D"}\nNumero Preventivo: ${currQuotation.code}\nData Preventivo: ${currQuotation.__referenceDateLabel}\nData Invio: ${currQuotation.__sendingDateLabel}`);
// 		}
// 	}
// });

// globalReportsView.addMethod("showQuotationConfirmationBtn_clickHandler", function (event, data) {
// 	const quotationList = Shark.get("quotationList");
// 	const currQuotation = Utils.safp(quotationList, "guid", data.guid);

// 	if (currQuotation) {
// 		const pictures = currQuotation.extraData.confirmData.pictures;
// 		window.open(`${Shark.get("__cdnURL")}/${pictures[pictures.length - 1].url}`, "_blank");
// 	}
// });

// globalReportsView.addMethod("singleItemBox_clickHandler", function (event, data) {
// 	if (event.target.classList.contains("notClickable")) {
// 		return;
// 	}

// 	const currSiteInfoSheet = Utils.safp(Shark.get("siteInfoSheetList"), "guid", data.guid);

// 	if (currSiteInfoSheet) {
// 		Shark.set({currSiteInfoSheet});
// 		followUpComponent.set("targetItem", currSiteInfoSheet);
// 		Shark.openPage(siteInfoSheetDisplayView);
// 	}
// });

// globalReportsView.addMethod("singleQuotationBox_clickHandler", function (event, data) {
// 	/*const currQuotation = Utils.safp(Shark.get("quotationList"), "guid", data.guid);
// 	Shark.set("currQuotation", currQuotation);*/
// 	const currQuotation = Shark.getInstance("Quotation", {
// 		// clientAddress: currSiteInfoSheet.clientAddressAndCity,
// 		// clientName: currSiteInfoSheet.clientName,
// 		// clientPersonInCharge: currSiteInfoSheet.clientPersonInCharge,
// 		createdByGuid: Shark.get("currUser").guid,
// 		documentDate: moment(),
// 		// ipmPersonInCharge: currSiteInfoSheet.siteIPMPersonInCharge,
// 		// siteInfoSheetGuid: currSiteInfoSheet.guid,
// 		// siteInspectionPictures: currSiteInfoSheet.pictures
// 	});

// 	Shark.set("currQuotation", currQuotation);

// 	Shark.openPage(quotationEditView);
// });

Shark.registerView(globalReportsView);

export { globalReportsView };
